import { GUIDANCE_DISABLED_KEY } from '../../utils/tourGuidance';

export interface TourState {
  completions: Record<string, string>; // tourId → ISO timestamp
  loaded: boolean;
}

export type TourAction =
  | { type: 'LOAD_TOUR_COMPLETIONS'; payload: Record<string, string> }
  | { type: 'TOUR_COMPLETED'; payload: { tourId: string; completions: Record<string, string> } }
  | { type: 'TOUR_RESET'; payload: { tourId: string; completions: Record<string, string> } }
  | { type: 'TOURS_RESET_ALL' }
  | { type: 'SET_GUIDANCE'; payload: boolean };

const initialState: TourState = {
  completions: {},
  loaded: false,
};

export const tourReducer = (state = initialState, action: TourAction): TourState => {
  switch (action.type) {
    case 'LOAD_TOUR_COMPLETIONS':
      return { ...state, completions: action.payload || {}, loaded: true };

    case 'TOUR_COMPLETED':
      return { ...state, completions: action.payload.completions };

    case 'TOUR_RESET':
      return { ...state, completions: action.payload.completions };

    case 'TOURS_RESET_ALL':
      return { ...state, completions: {} };

    case 'SET_GUIDANCE': {
      const completions = { ...state.completions };
      if (action.payload) {
        delete completions[GUIDANCE_DISABLED_KEY];
      } else {
        completions[GUIDANCE_DISABLED_KEY] = 'disabled';
      }
      return { ...state, completions };
    }

    default:
      return state;
  }
};
